import { createAction } from '@reduxjs/toolkit';
import { Signer } from 'ethers';
import { nftSlice } from './slice';

type CheckApprovals = (signer: Signer, chainId: number) => { payload: { signer: Signer; chainId: number } };

export const checkApprovals = createAction<CheckApprovals>(
  'nft/check_approvals',
  (signer: Signer, chainId: number) => ({
    payload: { signer, chainId },
  }),
);

type MakeApproval = (
  signer: Signer,
  tokenAddress: string,
  chainId: number,
  onFinish: (success: boolean) => void,
) => { payload: { signer: Signer; tokenAddress: string; chainId: number }; meta: (success: boolean) => void };

export const makeApproval = createAction<MakeApproval>(
  'nft/make_approval',
  (signer: Signer, tokenAddress: string, chainId: number, onFinish) => ({
    payload: { signer, tokenAddress, chainId },
    meta: onFinish,
  }),
);

export const { storeCheckedApprovals, storeApproval, storeNumTokens } = nftSlice.actions;
